<script>

    import { toast } from 'bulma-toast'
    import { errorsStore, modalStore } from '../stores'

    import ErrorsService from '../$services/errors.service'
    import DateMethod from '../$methods/date.method'

    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    let query = {
        page: 0,
        find: null,
        provider: null,
        service: null,
    }
    let metadata = {}
    let loading = false

    getErrors()

    async function getErrors() {

        loading = true
        const resp = await ErrorsService.getErrors(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        errorsStore.set(resp.data.errors)
        metadata = resp.data.metadata
    }

</script>

<Table
    items={ $errorsStore.length }
    total={ metadata.total }
    { loading }
    skeletonCols={8}
    bind:metadata
    bind:page={ query.page }
    on:change={ getErrors }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getErrors } />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-life-ring"></i></span>
                    <span>Código soporte</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Proveedor</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-handshake"></i></span>
                    <span>Partner</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-shipping-fast"></i></span>
                    <span>Servicio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-comment"></i></span>
                    <span>Mensaje</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $errorsStore as error, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                <td><code>{ error.code }</code></td>
                <td>{ error.provider }</td>
                <td>{ error.partner || error.provider }</td>
                <td>{ error.service }</td>
                <td class="is-size-7">{ error.message }</td>
                <td>{ DateMethod.dateTimeLarge(error.created) }</td>
                <td>
                    <Button on:click={() => modalStore.open('error', 'modal', error)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
